<template>
    <div class="inbox cursor-pointer mr-2" v-if="shouldDisplayInbox" @click.prevent="openInboxChats">
      <vs-button
        icon-pack="feather"
        icon="icon-inbox"
        class="inbox__inactive"
        :class="{ 'inbox__active': isInboxChat }"
        :type="isInboxChat ? 'line' : 'flat'"
        />
      <span
        v-if="inboxSum !== 0"
        class="text-center"
        :class="shouldDisplayMessagesNotification ? 'inbox__notification active' : 'inbox__notification'"
      > 
        <small class="text-white"> {{inboxSum}} </small>
      </span>
    </div>
</template>

<script>
import { CustomerGroupService } from "@/db/customerGroup_service";
import { populateQuerySum } from "@/utils";

export default {
  data() {
    return {
      inboxSum: 0,
      cgService: null,
      shouldDisplayInbox: false,
    };
  },
  computed: {
    isInboxChat() {
      return this.$store.state.chatContact.chatTab === 'inbox';
    },
    shouldDisplayMessagesNotification() {
      return this.$store.state.chatContact.inboxMessagesStatus === 'unseen';
    },
    chatFilter(){
      return this.$store.state.chatContact.chatFilter
    }
  },
  watch: {
    '$store.state.chatSettings.sumOfTickets': {
      handler: 'filterInboxSum',
      immediate: false,
      deep: true
    },
    '$store.state.chatContact.chatFilter'() {
      this.filterInboxSum();
    }
  },
  methods: {
    async filterInboxSum(){
      const tickets = this.$store.state.chatSettings.sumOfTickets.inbox_list;
      const resolve = await Promise.all(tickets.map(async (ticket) => { return await populateQuerySum(this.cgService, this.chatFilter, ticket); }));
      const sum = resolve.filter(result => result).length;
      this.inboxSum = sum < 100 ? sum : '+99'
      this.$emit('updateInboxChatSum', this.inboxSum)
    },
    async shouldDisplay() {
      const response = await this.$store.dispatch('settings/fetch');
      if (response) {
        const {data: {data: {settings = []} = {}} = {}} = response;
        const inboxActive = settings
            .find(({name, value}) => {
              return name === 'relate_chat_tickets_to_next_user'
                  && !parseInt(value);
            });
        return inboxActive !== undefined;
      }
    },
    openInboxChats() {
      this.$store.dispatch('chatContact/setInboxMessagesStatus', 'seen');
      this.$emit('openInboxChats');
    },
  },
  async mounted() {
    this.shouldDisplayInbox = await this.shouldDisplay();
    this.cgService = new CustomerGroupService();
    this.filterInboxSum()

    this.$events.on('RefreshCountObservable', () => {
      this.filterInboxSum()
    })
  },
}
</script>

<style lang="scss">
.inbox {
  position: relative;

  &__inactive[style] .vs-icon {
    color: #626262 !important;
  }

  &__inactive[style] .vs-button-backgroundx {
    opacity: 1 !important;
    left: 20px !important;
    top: 20px !important;
    width: 0px !important;
    height: 0px !important;
    transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s !important;
  }

  &__active[style] .vs-icon {
    color: rgba(var(--vs-primary), 1) !important;
  }

  &__active[style].vs-button-primary.vs-button-line {
    border-color: rgba(var(--vs-primary), 1) !important;
  }

  .icon-inbox:before {
    font-size: 25px;
  }

  &__notification {
    top: -9px;
    left: 20px;
    width: 21px;
    height: 21px;
    z-index: 999;
    border-radius: 50%;
    position: absolute;
    background: #ff8974;
  }

  .active {
    background: #f24423;
  }
}
</style>
